import type { IBaseDoctor, IDoctor } from '@/entities/doctor/model/types';
import type { Skill } from '@/entities/skill/model/types';

import type { ProfiledDoctorCardProps } from '../model/types';

export const adaptDoctorToCard = (
  doctor: IBaseDoctor | IDoctor,
  visibleSkill?: Skill | null,
  city?: string,
): ProfiledDoctorCardProps => {
  const getDoctorSkill = (): string => {
    if (visibleSkill) return visibleSkill.name;
    if (doctor.skills.length > 0) return doctor.skills[0].name;
    return '';
  };

  return {
    fullName: doctor.fullName,
    workExperience: doctor.workExperience,
    rating: doctor.rating,
    avatar: doctor.avatar,
    alias: doctor.alias,
    skill: getDoctorSkill(),
    href: `/${city}/doctor/${doctor.alias}`,
  };
};
